import { useCallback } from "react";

const useFormData = () => {
    /**
     * Recursively converts an object into FormData.
     *
     * @param {any} data - The data to convert.
     * @param {FormData} formData - The FormData instance.
     * @param {string|null} parentKey - The parent key for nested data.
     * @returns {FormData}
     */
    const convertToFormData = useCallback((data, formData = new FormData(), parentKey = null) => {
        console.log("Form Data Hook:::::", data);
        // If data is an object but not a File, Blob, or Date, process it recursively.
        if (
            data &&
            typeof data === "object" &&
            !(data instanceof File) &&
            !(data instanceof Blob) &&
            !(data instanceof Date)
        ) {
            if (Array.isArray(data)) {
                data.forEach((item, index) => {
                    // For arrays, use bracket notation.
                    const key = parentKey ? `${parentKey}[${index}]` : index;
                    convertToFormData(item, formData, key);
                });
            } else {
                Object.keys(data).forEach((key) => {
                    const value = data[key];
                    const formKey = parentKey ? `${parentKey}[${key}]` : key;
                    convertToFormData(value, formData, formKey);
                });
            }
        } else {
            // Handle Date objects by converting them to ISO strings.
            if (data instanceof Date) {
                formData.append(parentKey, data.toISOString());
            } else if (data === null || data === undefined) {
                // Append empty string for null/undefined values.
                formData.append(parentKey, "");
            } else {
                // Files, Blobs, and primitive types are appended directly.
                formData.append(parentKey, data);
            }
        }
        return formData;
    }, []);

    return convertToFormData;
};

export default useFormData;
